import type { ReactNode } from 'react';
type Props = {
  title?: string;
  description?: string;
  actions?: ReactNode;
  /** Geen binnenruimte: voor lijsten met eigen rijen. De kop krijgt een lijn eronder. */
  flush?: boolean;
  className?: string;
  children: ReactNode;
};

/** Een wit vlak voor één groep velden. */
export function Panel({
  title,
  description,
  actions,
  flush = false,
  className = '',
  children
}: Props) {
  return <section className={`rounded-lg border border-line bg-white ${flush ? '' : 'p-4 sm:p-6'} ${className}`} data-id="element-5115" data-mp="pmxy8owry906">
      {(title || actions) && <div className={`flex items-start justify-between gap-4 ${flush ? 'border-b border-line px-4 py-4 sm:px-5' : 'mb-5'}`} data-id="element-5116" data-mp="kuob1gn1nn1l">
          <div className="min-w-0" data-id="element-5117" data-mp="bv9lqkim5iio">
            {title && <h2 className="text-[15px] font-medium text-ink" data-id="element-5118" data-mp="bwkpwlfz0sab">{title}</h2>}
            {description && <p className="mt-0.5 text-[13px] leading-snug text-muted" data-id="element-5119" data-mp="6v56syxcsvuk">{description}</p>}
          </div>
          {actions}
        </div>}
      {children}
    </section>;
}